module.exports = __webpack_public_path__ + "static/img/qrcode-app-doctor.9acbb74d.png";